import { render, staticRenderFns } from "./ClusterMembershipEditor.vue?vue&type=template&id=5c5cf640&"
import script from "./ClusterMembershipEditor.vue?vue&type=script&lang=js&"
export * from "./ClusterMembershipEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports